/**
 * Claims RTK Query tag-type registry (claims module).
 *
 * Mirrors the financialClearance module pattern (`modules/financialClearance/data/tags.ts`): all
 * tag types are declared up-front here and passed to the single base `createApi` (see
 * `claimsApi.ts`). `injectEndpoints` cannot introduce new tag types, so any tag a feature endpoint
 * provides or invalidates MUST be listed here.
 */
export const CLAIMS_TAG_TYPES = ['ClaimQueue', 'Claim', 'UnmatchedException'] as const;

export type ClaimsTagType = (typeof CLAIMS_TAG_TYPES)[number];
